module.exports = __webpack_public_path__ + "img/photo3_2.5490122a.jpg";